import React from 'react';

// Components
import {Icon} from '@drivesally/sally-ui';
import Container from './components/Container';

const Loader = () => (
  <Container>
    <Icon icon="loading2" spin />
  </Container>
);

export default Loader;
